module.exports = __webpack_public_path__ + "media/pages/book/components/images/main-features/bulb-aeeefecd48fdf887973a6b7869843336.svg";